export default __webpack_public_path__ + "static/media/AutomationAlert.774bce1b.svg";